export enum PostStatus {
    PUBLISHED = 'published',
    DRAFT = 'draft',
    DELETED = 'deleted',
    LIMITED = 'limited',
    DECLINED = 'declined',
    MODERATION = 'moderation',
}

export enum PostSource {
    INSTAGRAM = 'instagram',
    MANUAL = 'manual',
    TELEGRAM = 'tg',
}
